// extracted by mini-css-extract-plugin
export default {"clickHere":"ClickHere_clickHere__1yyRY"};